import bootstrap from '../images/technologies/bootstrap.svg';
import css from '../images/technologies/css3.svg';
import firebase from '../images/technologies/firebase.svg';
import gulp from '../images/technologies/gulp.svg';
import html from '../images/technologies/html5.svg';
import js from '../images/technologies/js.svg';
import mongodb from '../images/technologies/mong.svg';
import react from '../images/technologies/react.svg';
import tailwind from '../images/technologies/tailwind.svg';
import redux from '../images/technologies/redux.svg';
import figma from '../images/technologies/figma.svg';
import git from '../images/technologies/git.svg';
import nodejs from '../images/technologies/nodejs.svg';
import webpack from '../images/technologies/webpack.svg';

export const technologies = [
  { title: 'HTML', link: html },
  { title: 'CSS', link: css },
  { title: 'JavaScript', link: js },
  { title: 'React', link: react },
  { title: 'Redux', link: redux },
  { title: 'Bootstrap', link: bootstrap },
  { title: 'Tailwind', link: tailwind },
  { title: 'Gulp', link: gulp },
  { title: 'Firebase', link: firebase },
  { title: 'MongoDb', link: mongodb },
  { title: 'Figma', link: figma },
  { title: 'Git', link: git },
  { title: 'NodeJS', link: nodejs },
  { title: 'Webpack', link: webpack },
];
